import React, { useMemo } from 'react';
import GridEditCellTemplateHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridEditCellTemplateHelper';
import EditCellTemplateProps from 'fulogics-ui-web/dist/layout/dx/DataGrid/templates/EditCellTemplateProps';
import Lookup, { LookupProps } from 'fulogics-ui-web/dist/layout/dx/Lookup/Lookup';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import ProductInfoModelSimpleText, {
    ProductInfoModelSimpleTextData,
    ProductInfoModelSimpleTextDataKeys,
} from '../../../../components/product-info-model-simple-text/ProductInfoModelSimpleText';
import { Template } from 'devextreme-react/core/template';
import ProductInfoModelSimpleTextItemTemplate from '../../../selectBox/item/product-info-model-simple-text-item-template/ProductInfoModelSimpleTextItemTemplate';
import DataSource from 'devextreme/data/data_source';
import { ProductInfoStore } from '../../../../../store/models/ProductInfoModel';

const defaultProps: LookupProps = {
    dataSource: 'ds~productInfosDataSource',
    displayExpr: 'name',
    showClearButton: true,
    searchEnabled: true,
    searchExpr: 'composite',
    dropDownOptions: {
        showTitle: false,
    },
};

const ProductInfoEditColumnTemplate = (props: EditCellTemplateProps) => {
    const data = gridCellData(props);
    //
    return (
        <React.Fragment>
            <GridEditCellTemplateHelper cellProps={props}>
                {(inspectorId, disableInspectorForm, setValueFunction) => (
                    <Lookup
                        defaultProps={defaultProps}
                        //
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        //
                        defaultValue={data?.id}
                        //
                        width="500px"
                        onValueChanged={(e) =>
                            setValueFunction(
                                e.component
                                    ?.getDataSource()
                                    ?.items()
                                    .find((x: ProductInfoModelSimpleTextData) => x.id == e.value) ??
                                    null,
                                '-'
                            )
                        }
                        //onValueChanged={(e) => setValueFunction(e.value, "-")}
                        //
                        itemTemplate={'ProductInfoModelSimpleTextItem'}
                        valueExpr="id"
                        //
                        {...props.column.lookup}
                        {...props.column.editorOptions}
                    >
                        <Template
                            name="ProductInfoModelSimpleTextItem"
                            render={ProductInfoModelSimpleTextItemTemplate}
                        />
                    </Lookup>
                )}
            </GridEditCellTemplateHelper>
        </React.Fragment>
    );
};

export default ProductInfoEditColumnTemplate;
